import { cloneObject } from '../../../../../utils';
import { getFields } from '../../../../../utils/defaultFields';

const fields = ['admissionDate', 'cellphone', 'email'];

const schema = {
    ...cloneObject(getFields(fields)),
    doctor: {
        id: 'doctor',
        label: 'Médico',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione um médico',
    },
    time: {
        id: 'time',
        label: 'Horário',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione um Horário',
    },
};

export default schema;
